import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-indie-paper">
        <div className="text-indie-navy label-editorial">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}
